import { HP, legSwing, pt } from '../enemy-parts';
/* ============================================================
   家族 SPIKE 錐 —— 細長前傾＋單一前指尖端
   ============================================================

   由 `tools/port-families.mjs` 從 `enemy_sample_ani.html` §5 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-families.mjs --check`（逐一比對數字字面值序列）。

   本族成員（威脅色決定身分，剪影決定家族）：
     NADEL   red 針蜂　斥候・群衝
     LANZE   amb 槍　定點・直射
     GEISSEL vio 災鞭　噴吐・扇形
     FÜHLER  azu 觸角　標定・增傷
     SPROSS  vio 芽　深層・歪斜突刺
     FADEN   azu 絲　深層・牽引標定

   `parts` 的材質名（armor/dark/trim/glow/armorE/glowE）由
   `enemy-parts.ts` 的 `enemyPalette(tint)` 解析 —— 型別表只寫形狀。 */

export var SPIKE = [

  /* ─ 1 ─────────────────────────────────────────────────────────
     NADEL 針蜂 —— 最便宜的量。剪影＝細長前傾＋一根鼻刺。
     它是全表唯一「前後長於左右」的小怪，所以俯視也認得出來。 */
  {
    id:'nadel', fam:'spike', code:'NADEL', zh:'針蜂', role:'斥候・群衝', tint:'red',
    sil:'細長前傾＋鼻刺', h:0.98, w:0.62, wt:4.2,
    spd:3.1, turn:3.4, gait:2.7, rng:1.6, tTel:0.26, tAtk:0.18, tRec:0.40,
    q0:{lg:1, pk:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'疾走', q:{lg:1.30}, sp:1.55, sc:0.86},
          {n:'突刺', q:{pk:1.85}, sp:0.82, sc:1.14}],
    parts:[
      pt('bev','dark', [0.34,0.30,0.68],[0,0.60,0.02],[0.20,0,0]),
      pt('box','armor',[0.30,0.09,0.56],[0,0.77,-0.05],[0.34,0,0]),
      pt('cone','armor',[0.19,0.56,0.19],[0,0.62,0.46],[1.32,0,0], function(P,o){
          P.sy *= o.q.pk; P.z += (o.q.pk-1)*0.20; }),
      pt('box','glow',[0.15,0.05,0.06],[0,0.71,0.30]),
      pt('cone','trim',[0.12,0.68,0.12],[ 0.20,0.34,-0.08],[Math.PI,0,0], legSwing( 1,0.34,0.42)),
      pt('cone','trim',[0.12,0.68,0.12],[-0.20,0.34,-0.08],[Math.PI,0,0], legSwing(-1,0.34,0.42))
    ],
    ex:[ pt('box','armorE',[0.44,0.10,0.42],[0,0.86,-0.16],[0.30,0,0]),
         pt('cone','armorE',[0.13,0.34,0.13],[ 0.17,0.80,-0.30],[-0.5,0,0.3]),
         pt('cone','armorE',[0.13,0.34,0.13],[-0.17,0.80,-0.30],[-0.5,0,-0.3]),
         pt('box','glowE',[0.05,0.05,0.44],[0,0.84,-0.02],[0.30,0,0]) ],
    pose:function(o){
      o.ry = 0.038*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.13 + 0.10*o.mv + o.tel*0.20 - o.atk*0.44;
      o.rr = 0.11*Math.sin(o.ph*Math.PI * 2)*o.mv;
      o.rz = -o.tel*0.18 + o.atk*0.85;
    }
  },
  /* ══════════════════════════════════════════════════════════════
     以下 20 種按「剪影家族」排。同家族共用外框，靠威脅色分身分。
     家族 × 顏色 = 身分，兩個軸在 20px 下都讀得到。
     ══════════════════════════════════════════════════════════════ */

  /* ── 家族 SPIKE 錐 ── 細長前傾、單一前指尖端。red 是 NADEL。 */
  {
    id:'lanze', fam:'spike', code:'LANZE', zh:'槍', role:'定點・直射', tint:'amb',
    sil:'細長前傾＋長砲管', h:1.06, w:0.58, wt:1.5,
    spd:1.9, turn:2.2, gait:2.0, rng:6.5, tTel:0.75, tAtk:0.22, tRec:0.95,
    q0:{lg:1, bl:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'速射', q:{bl:0.76}, sp:1.28, sc:0.90},
          {n:'長管', q:{bl:1.42}, sp:0.76, sc:1.12}],
    parts:[
      pt('bev','dark', [0.32,0.30,0.60],[0,0.62,-0.04],[0.16,0,0]),
      pt('box','armor',[0.34,0.10,0.48],[0,0.79,-0.10],[0.30,0,0]),
      pt('cyl','armor',[0.16,0.88,0.16],[0,0.70,0.46],[HP,0,0], function(P,o){
          P.sy *= o.q.bl; P.z += (o.q.bl-1)*0.44 - o.atk*0.24; }),
      pt('tor','glow', [0.30,0.30,0.60],[0,0.70,0.92],null, function(P,o){
          P.z += (o.q.bl-1)*0.88 - o.atk*0.24;
          var k = 1 + 1.4*o.tel + 2.6*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; }),
      pt('cone','trim',[0.12,0.62,0.12],[ 0.19,0.31,-0.10],[Math.PI,0,0], legSwing( 1,0.31,0.30)),
      pt('cone','trim',[0.12,0.62,0.12],[-0.19,0.31,-0.10],[Math.PI,0,0], legSwing(-1,0.31,0.30))
    ],
    ex:[ pt('box','armorE',[0.42,0.10,0.36],[0,0.88,-0.20],[0.28,0,0]),
         pt('cyl','glowE', [0.07,0.42,0.07],[0,0.80,0.16],[HP,0,0]) ],
    pose:function(o){
      o.ry = 0.03*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.10 + 0.06*o.mv - o.tel*0.11 + o.atk*0.18;
      o.rz = -o.atk*0.14;
    }
  },
  {
    id:'geissel', fam:'spike', code:'GEISSEL', zh:'災鞭', role:'噴吐・扇形', tint:'vio',
    sil:'細長前傾＋粗噴口', h:1.02, w:0.70, wt:1.2,
    spd:2.2, turn:2.8, gait:2.4, rng:4.2, tTel:0.80, tAtk:0.55, tRec:0.85,
    q0:{lg:1, nz:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'短噴', q:{nz:0.78}, sp:1.30, sc:0.90},
          {n:'廣噴', q:{nz:1.40}, sp:0.80, sc:1.14}],
    parts:[
      pt('bev','dark', [0.36,0.32,0.58],[0,0.60,-0.06],[0.18,0,0]),
      pt('cyl','armor',[0.34,0.42,0.34],[0,0.76,-0.30],[HP,0,0]),
      pt('cone','armor',[0.46,0.46,0.46],[0,0.64,0.40],[-HP,0,0], function(P,o){
          var k = o.q.nz; P.sx*=k; P.sz*=k; P.sy *= 1 + 0.30*o.atk; }),
      pt('tor','glow', [0.40,0.40,0.55],[0,0.64,0.60],null, function(P,o){
          var k = o.q.nz*(1 + 0.5*o.tel + 1.6*o.atk); P.sx*=k; P.sy*=k; }),
      pt('cone','trim',[0.13,0.58,0.13],[ 0.21,0.29,-0.12],[Math.PI,0,0], legSwing( 1,0.29,0.36)),
      pt('cone','trim',[0.13,0.58,0.13],[-0.21,0.29,-0.12],[Math.PI,0,0], legSwing(-1,0.29,0.36))
    ],
    ex:[ pt('cyl','armorE',[0.26,0.34,0.26],[ 0.26,0.82,-0.28],[HP,0,0]),
         pt('cyl','armorE',[0.26,0.34,0.26],[-0.26,0.82,-0.28],[HP,0,0]) ],
    pose:function(o){
      o.ry = 0.035*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.12 + 0.08*o.mv - o.tel*0.22 + o.atk*0.30;
      o.rz = -o.tel*0.14;
    }
  },
  {
    id:'fuhler', fam:'spike', code:'FÜHLER', zh:'觸角', role:'標定・增傷', tint:'azu',
    sil:'細長前傾＋上挑細角', h:1.30, w:0.54, wt:0.6,
    spd:2.5, turn:3.0, gait:2.5, rng:7.2, tTel:0.95, tAtk:0.40, tRec:1.10,
    q0:{lg:1, an:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'遊走', q:{an:0.80}, sp:1.40, sc:0.88},
          {n:'高塔', q:{an:1.45}, sp:0.70, sc:1.16}],
    parts:[
      pt('bev','dark', [0.30,0.28,0.54],[0,0.58,-0.02],[0.14,0,0]),
      pt('box','armor',[0.30,0.10,0.44],[0,0.73,-0.08],[0.26,0,0]),
      pt('cone','armor',[0.13,0.86,0.13],[0,1.02,0.22],[-0.52,0,0], function(P,o){
          P.sy *= o.q.an; P.y += (o.q.an-1)*0.32; P.rx -= o.tel*0.30; }),
      pt('oct','glow', [0.20,0.20,0.20],[0,1.42,0.44],null, function(P,o){
          P.y += (o.q.an-1)*0.66; P.z -= o.tel*0.16;
          var k = 1 + 0.4*Math.sin(o.t*5) + 1.8*o.tel + 2.2*o.atk*(1-o.atk);
          P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('cone','trim',[0.11,0.58,0.11],[ 0.17,0.29,-0.08],[Math.PI,0,0], legSwing( 1,0.29,0.34)),
      pt('cone','trim',[0.11,0.58,0.11],[-0.17,0.29,-0.08],[Math.PI,0,0], legSwing(-1,0.29,0.34))
    ],
    ex:[ pt('tor','glowE',[0.34,0.34,0.5],[0,1.16,0.34],[0.9,0,0]),
         pt('box','armorE',[0.36,0.08,0.30],[0,0.82,-0.16],[0.24,0,0]) ],
    pose:function(o){
      o.ry = 0.04*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.09 + 0.06*o.mv - o.tel*0.16;
      o.rr = 0.10*Math.sin(o.ph*Math.PI * 2)*o.mv;
    }
  },
  /* ══════════════════════════════════════════════════════════════
     深層小怪 12 種 —— 它們沒有自己的家族。
     28 種正規小怪已經把「東西應該長成八種樣子之一」訓練進玩家腦裡了，
     所以深層不是第九個家族，而是**第三個軸**：

         家族（外框） × 威脅色（怎麼傷你） × 階層（正規 / 深層）

     8 × 4 × 2 = 64 格。玩家多學一件事，換到多一倍的身分。
     深層的辨識規則只有兩條，兩條都在 20px 下讀得到：
       1. 身上有一個「洞」—— M.void，不受光的死黑，讀作被挖掉而不是塗黑
       2. 左右不對稱 —— 正規小怪一律鏡像，深層一律歪掉
     ══════════════════════════════════════════════════════════════ */
  {
    id:'spross', fam:'spike', deep:1, code:'SPROSS', zh:'芽', role:'深層・歪斜突刺', tint:'vio',
    sil:'細長前傾＋歪掉的粗錐', h:1.08, w:0.68, wt:1.3,
    spd:2.4, turn:2.6, gait:2.3, rng:2.2, tTel:0.40, tAtk:0.26, tRec:0.55,
    q0:{lg:1, pk:1},
    vars:[{n:'標準', q:{}, sp:1.00, sc:1.00},
          {n:'速生', q:{lg:1.26}, sp:1.44, sc:0.88},
          {n:'瘤', q:{pk:1.50}, sp:0.80, sc:1.16}],
    parts:[
      pt('bev','dark',[0.36,0.32,0.62],[0,0.62,-0.02],[0.18,0,0]),
      pt('cone','armor',[0.30,0.86,0.30],[0.11,0.70,0.44],[1.22,0,-0.30], function(P,o){
          P.sy *= o.q.pk; P.z += (o.q.pk-1)*0.32; P.rz -= o.tel*0.22; }),
      pt('oct','void',[0.44,0.44,0.44],[-0.14,0.84,-0.16], null, function(P,o){
          var k = 1 + 0.5*o.tel; P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('tor','glow',[0.60,0.60,0.45],[-0.14,0.84,-0.16],[0.5,0.3,0], function(P,o){
          P.rz += o.t*1.1; var k = 1 + 0.9*o.tel + 1.8*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; }),
      pt('cone','trim',[0.13,0.64,0.13],[ 0.22,0.32,-0.08],[Math.PI,0,0], legSwing( 1,0.32,0.40)),
      pt('cone','trim',[0.11,0.52,0.11],[-0.17,0.26,-0.12],[Math.PI,0,0], legSwing(-1,0.26,0.44))
    ],
    ex:[ pt('cone','armorE',[0.16,0.40,0.16],[0.26,0.86,-0.24],[-0.6,0,0.4]),
         pt('oct','glowE',[0.20,0.20,0.20],[-0.26,0.92,0.06]) ],
    pose:function(o){ o.ry = 0.04*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.14 + 0.10*o.mv + o.tel*0.18 - o.atk*0.40;
      o.rr = 0.14*Math.sin(o.ph*Math.PI * 2)*o.mv + 0.06; o.rz = o.atk*0.80; }
  },
  {
    id:'faden', fam:'spike', deep:1, code:'FADEN', zh:'絲', role:'深層・牽引標定', tint:'azu',
    sil:'細長前傾＋極細前絲', h:1.16, w:0.44, wt:0.6,
    spd:2.7, turn:3.2, gait:2.6, rng:6.8, tTel:0.90, tAtk:0.45, tRec:1.05,
    q0:{lg:1, th:1},
    vars:[{n:'標準', q:{}, sp:1.00, sc:1.00},
          {n:'游絲', q:{th:0.72}, sp:1.46, sc:0.86},
          {n:'長絲', q:{th:1.55}, sp:0.74, sc:1.12}],
    parts:[
      pt('bev','dark',[0.26,0.26,0.54],[0,0.58,-0.04],[0.14,0,0]),
      pt('cyl','armor',[0.09,1.30,0.09],[0.06,0.66,0.60],[HP,0,0.12], function(P,o){
          P.sy *= o.q.th; P.z += (o.q.th-1)*0.62; }),
      pt('oct','void',[0.34,0.34,0.34],[-0.10,0.74,0.02]),
      pt('tor','glow',[0.52,0.52,0.40],[-0.10,0.74,0.02],[0,HP,0], function(P,o){
          P.rz += o.t*(0.8 + 4*o.tel);
          var k = 1 + 1.2*o.tel + 1.6*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; }),
      pt('cone','trim',[0.10,0.56,0.10],[ 0.15,0.28,-0.06],[Math.PI,0,0], legSwing( 1,0.28,0.34)),
      pt('cone','trim',[0.10,0.62,0.10],[-0.13,0.31,-0.14],[Math.PI,0,0], legSwing(-1,0.31,0.38))
    ],
    ex:[ pt('tor','glowE',[0.72,0.72,0.30],[-0.10,0.74,0.02],[HP,0,0]),
         pt('cyl','armorE',[0.06,0.34,0.06],[0.18,0.86,-0.14],[0.4,0,0.3]) ],
    pose:function(o){ o.ry = 0.05*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.08 + 0.06*o.mv - o.tel*0.14; o.rr = 0.16*Math.sin(o.ph*Math.PI * 2)*o.mv - 0.05; }
  }
];
